type FilepickerOptions = {
}

class Filepicker {
    elContainer:      HTMLElement;

    multiple: boolean;
    required: boolean;

    elUpload:         HTMLElement;
    elUploadValue:    HTMLInputElement;

    elValues:         HTMLElement;
    elTemplate:       HTMLElement;

    constructor(container: Element, opts: Partial<FilepickerOptions> = {}) {
        this.elContainer  = container as HTMLElement;

        this.elUpload        = container.querySelector('.filepicker-upload') as HTMLElement;
        this.elUploadValue   = this.elUpload?.querySelector('input.form-input-value') as HTMLInputElement;

        this.elValues        = container.querySelector('.filepicker-values') as HTMLElement;
        this.elTemplate      = this.elValues.querySelector('.filepicker-template') as HTMLElement;

        this.multiple        = this.elUploadValue?.hasAttribute("multiple");
        this.required        = this.elUploadValue?.hasAttribute("required");

        this.init();
    }

    init() {

        // If field is not multiple and already has a value, we hide the upload element
        if (!this.multiple && this.hasValue()) {
            this.hideUpload();
        }

        if (this.elUploadValue) {

            let handleFileUpload = (e: Event) => {
                // Instanciate template
                const inst = this.elTemplate.cloneNode(true) as HTMLElement;

                inst.classList.remove('filepicker-template');
                inst.classList.add('filepicker-value');

                // Generate preview
                const file = (e.target as HTMLInputElement).files[0];

                const name = document.createElement('span');
                name.classList.add('filename');
                name.innerText = file.name;

                inst.querySelector(".filepicker-value-preview").prepend(name);

                if (file.type.match(/^image\//)) {
                    const icon = document.createElement('div');
                    icon.classList.add('icon');

                    const img = document.createElement('img');
                    img.src = URL.createObjectURL(file);

                    icon.appendChild(img);

                    inst.querySelector(".filepicker-value-preview").prepend(icon);
                }

                // Copy file upload value to template value
                let input = inst.querySelector("input") as HTMLInputElement;

                let newUploadValue = this.elUploadValue.cloneNode(false) as HTMLInputElement;

                newUploadValue.removeEventListener('change', handleFileUpload);

                this.elUploadValue.removeAttribute("id");
                this.elUploadValue.removeAttribute("class");
                this.elUploadValue.setAttribute('name', this.elUploadValue.getAttribute('data-name'));

                input.replaceWith(this.elUploadValue)

                this.elUploadValue = newUploadValue;
                this.elUploadValue.value = '';

                this.elUploadValue.addEventListener('change', handleFileUpload)

                // Add new value
                this.elValues.insertBefore(inst, this.elTemplate);

                this.initValue(inst);

                if (!this.multiple) {
                    this.hideUpload();
                }

                if (this.required) {
                    this.elUploadValue.removeAttribute('required');
                }
            }

            this.elUploadValue.addEventListener('change', handleFileUpload)
        }

        this.elValues.querySelectorAll(".filepicker-value").forEach((el: HTMLElement) => {
            this.initValue(el)
        });

        if (this.hasValue && this.required) {
            this.elUploadValue.removeAttribute('required');
        }

        // Prevent the browser's default behavior (opening the file) for the whole zone
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            this.elContainer.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();
            });
        });

        this.elContainer.addEventListener('drop', (e) => {
            const files = e.dataTransfer.files;
            if (!files.length) return;

            this.elUploadValue.files = files;

            this.elUploadValue.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    hasValue(): boolean {
        return this.elValues.querySelectorAll(".filepicker-value").length > 0;
    }

    hideUpload() {
        if (this.elUploadValue) {
            this.elUploadValue.setAttribute("disabled", "");
        }

        if (this.elUpload) {
            this.elUpload.classList.add("hidden");
        }
    }

    showUpload() {
        if (this.elUploadValue) {
            this.elUploadValue.removeAttribute("disabled");
        }
        
        if (this.elUpload) {
            this.elUpload.classList.remove("hidden");
        }
    }

    initValue(elValue: HTMLElement) {
        elValue.querySelector('.filepicker-delete')?.addEventListener('click', (e) => {
            elValue.remove();

            if (!this.multiple) {
                this.showUpload();
            }

            if (!this.hasValue() && this.required) {
                this.elUploadValue.setAttribute('required', '');
            }
        })
    }
}

export { Filepicker };